export default {"src":"/_next/static/media/Home_myket.6a71ebae.svg","height":80,"width":80};